import { render, staticRenderFns } from "./InlineSwitch.vue?vue&type=template&id=5fb79296&scoped=true&"
import script from "./InlineSwitch.vue?vue&type=script&lang=js&"
export * from "./InlineSwitch.vue?vue&type=script&lang=js&"
import style0 from "./InlineSwitch.vue?vue&type=style&index=0&id=5fb79296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb79296",
  null
  
)

export default component.exports